import React, { useCallback } from 'react'
import { Col, Row, Label, FormGroup, FormFeedback, Input } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { SelectWithLabel } from '..'
import { lang } from 'utils/helpers'


/**
 * Select Fixed options
 * @param {object} props
 * @param {string} props.label
 * @param {[{_id: string, name: string, data: object}]} props.options
 * @param {[{_id: string, name: string, data: object, isFixed: boolean}]} props.values
 * @param {function} props.onChange
 * @param {string} [props.errors]
 * @param {string} [props.className]
 * @param {boolean} [props.isMultiline]
 * @param {boolean} [props.isDisabled]
 */
const SelectFixedOptions = function (props) {
  const {
    label, isMultiline = false, isDisabled = false, options, values = '',
    error = '', className = '', type, onChange
  } = props

  const onSelected = useCallback(
    (value, { action, removedValue }) => {
      switch (action) {
        case 'remove-value':
        case 'pop-value': {
          if (removedValue.isFixed) return
          break
        }
        case 'clear': {
          value = values.filter((v) => v.isFixed)
          break
        }
        default:
          break
      }

      onChange(type, isMultiline ? value || [] : value.value)
    },
    [values, onChange, isMultiline, type]
  )

  return (
    <Row className={className}>
      <Col xs='12'>
        <FormGroup>
          <Label for={label}>{I18n.t(label)}</Label>
          <SelectWithLabel
            multi={isMultiline}
            options={options}
            isClearable={values.some((v) => !v.isFixed)}
            value={values}
            selectedValues={values}
            onChange={onSelected}
            isDisabled={isDisabled}
            placeholder={lang('dashboard_select')}
            isRequiredAll
          />
          <Input hidden invalid={!!error} />
          <FormFeedback>{error ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default SelectFixedOptions
